import app from 'app';

export default {
  state() {
    return {
      brandColors: [],
      customWallpapers: [],
    };
  },

  // @param [state, getters]
  getters: {},

  // @param [state]
  // @param [payload]
  mutations: {
    setBrandColors(state, colors) {
      colors = colors || [];
      colors = colors.slice(0, 15).map((color) => {
        // brand colors are weird - the first 2 hex digits are the alpha channel
        return {
          name: color.name,
          _source: 'brand',
          wallpaperType: 'SOLID',
          wallpaperData: {
            colorValue: app.getRgbaString(color.value),
          },
        };
      });
      state.brandColors = colors;
    },

    addCustomWallpaper(state, wallpaper) {
      const o = Object.assign({}, wallpaper, { _source: 'custom' });
      delete o.name;
      state.customWallpapers.unshift(o);
    },

    setCustomWallpapers(state, wallpapers) {
      for (const w of wallpapers) {
        w._source = 'custom';
      }
      state.customWallpapers = [...wallpapers];
    },

    touchWallpaper(state, wallpaper) {
      const i = _.findIndex(state.customWallpapers, { id: wallpaper.id });
      const el = state.customWallpapers[i];
      state.customWallpapers.splice(i, 1);
      state.customWallpapers.unshift(el);
    },
    deleteWallpaper(state, wallpaper) {
      const i = _.findIndex(state.customWallpapers, { id: wallpaper.id });
      state.customWallpapers.splice(i, 1);
    },
  },

  // @param context {{state, rootState, commit, dispatch, getters, rootGetters}}
  // @param payload
  actions: {
    ADD_CUSTOM_WALLPAPER({ commit }, wallpaper) {
      wallpaper = _.cloneDeep(wallpaper);
      return app.api.wallpapers.post(wallpaper).then((id) => {
        wallpaper.id = id;
        commit('addCustomWallpaper', wallpaper);
        return id;
      });
    },

    GET_WALLPAPERS({ commit }) {
      return app.api.wallpapers.get().then((wallpapers) => {
        commit('setCustomWallpapers', wallpapers);
      });
    },

    TOUCH_WALLPAPER({ commit }, wallpaper) {
      commit('touchWallpaper', wallpaper);
      return app.api.wallpapers.touch(wallpaper.id);
    },

    DELETE_WALLPAPER({ commit }, wallpaper) {
      app.api.wallpapers.delete(wallpaper.id);

      commit('deleteWallpaper', wallpaper);
    },
  },
};
